module.exports = __webpack_public_path__ + "assets/img/banner3.c0e441d9.png";